import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, lifecycle, withState } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import ReactSelectMaterialUi from 'react-select-material-ui';
import { TableBody } from '@material-ui/core';
import BackButton from '../../components/atoms/BackButton';
import RegisterButton from '../../components/atoms/RegisterButton';
import ImagePreview from '../../components/molecules/ImagePreview';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { languages, languageType } from '../../constants/Language';
import enabledStripeBilling from '../../constants/StripeBilling';

const styles = {
  root: {
    width: '100%',
    height: 'auto',
    maxHeight: '100%',
    top: '5%',
    backgroundColor: '#fff',
    padding: 10,
    overflow: 'auto',
    outline: 'none',
    borderRadius: 4,
    paddingBottom: 10
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: 0,
    boxShadow: 'none'
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  description: {
    color: '#707070',
    margin: '20px 0px 0px'
  },
  subTitle: {
    margin: '20px 0px 0px',
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  divider: {
    margin: '20px 0px'
  },
  detailTable: {
    width: '100%'
  },
  tableCellItem: {
    borderBottom: '1px solid #DDDDDD',
    borderTop: '1px solid #DDDDDD',
    backgroundColor: '#F7F7F7',
    fontSize: 12,
    fontWeight: 'bold',
    padding: 10,
    width: 100
  },
  tableCellData: {
    borderTop: '1px solid #DDDDDD',
    borderBottom: '1px solid #DDDDDD',
    padding: '12px 10px',
    fontSize: 12,
    whiteSpace: 'pre-line'
  },
  textField100: {
    padding: '0px 5px 0px 5px',
    width: '100px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '100%'
  },
  textFieldLong: {
    padding: '0px 5px 0px 5px',
    width: '100%'
  },
  editTable: {
    width: 'auto'
  },
  tableCell: {
    border: '2px solid #ffffff'
  },
  titleDetail: {
    fontSize: 20,
    fontWeight: 'bold',
    padding: '5px 0 10px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    name: state.loginInfo.name,
    taxTypes: state.gochiMenus.taxTypes
  })),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  setPropTypes(propTypes),
  lifecycle({
    componentDidMount() {
      this.props.setIsLanguage(this.props.currentLanguage);
    }
  })
);

const Main = enhance(
  ({
    classes,
    backAction,
    editAction, // roles,
    editConfirm,
    taxTypes,
    reducedTaxMenuPrefix,
    openEditProgress,
    progressOkAction,
    loading,
    resultMessage,
    isLanguage,
    setIsLanguage,
    previewImage,
    menuGenreName,
    menuSituationNames,
    menuUserTargetNames,
    isFukuoka
  }) => {
    let { menuName, promotionDescription, description } = editConfirm;

    if (isLanguage !== languageType.ORIGIN) {
      const languageData = editConfirm.otherLanguages.find(
        language => language.language === isLanguage
      );
      if (languageData && languageData.translateType) {
        ({ menuName, promotionDescription, description } = languageData.params);
      } else {
        menuName = 'Google Translate で自動的に翻訳されるもの';
        promotionDescription = 'Google Translate で自動的に翻訳されるもの';
        description = 'Google Translate で自動的に翻訳されるもの';
      }
    }
    return (
      <div className={classes.root}>
        <Typography variant="h6" className={classes.titleDetail}>
          {isFukuoka ? 'コース編集確認' : 'メニュー編集確認'}
        </Typography>
        <Paper className={classes.mainPaper} elevation={1}>
          <ReactSelectMaterialUi
            required
            className={classes.textField}
            defaultValue={isLanguage}
            value={isLanguage}
            options={languages}
            margin="normal"
            onChange={v => {
              if (isLanguage === v) {
                return;
              }
              setIsLanguage(v);
            }}
          />
          <Table className={classes.detailTable}>
            <TableBody>
              {parseInt(editConfirm.menuChildType, 10) !== 3 &&
                parseInt(editConfirm.menuChildType, 10) !== 4 &&
                !isFukuoka && (
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      店舗名
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {editConfirm.shopName}
                    </TableCell>
                  </TableRow>
                )}
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  {isFukuoka ? 'コース名' : 'メニュー名'}
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {(() => {
                    if (editConfirm.reducedTaxType === 'REDUCED') {
                      return reducedTaxMenuPrefix;
                    }
                    return '';
                  })()}
                  {menuName}
                </TableCell>
              </TableRow>
              {editConfirm.menuChildType !== 3 && !isFukuoka && (
                <TableRow>
                  <TableCell className={classes.tableCellItem}>区分</TableCell>
                  <TableCell className={classes.tableCellData}>
                    {(() => {
                      if (editConfirm.comboMenu === 0) {
                        return '普通';
                      }
                      return '回数券';
                    })()}
                  </TableCell>
                </TableRow>
              )}
              {editConfirm.comboMenu === 0 && !isFukuoka && (
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    利用方法
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {editConfirm.menuLimitTotal === 1
                      ? '一円単位利用'
                      : '一枚単位利用'}
                  </TableCell>
                </TableRow>
              )}
              {editConfirm.subscription === 1 && enabledStripeBilling === true && (
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    購入頻度設定
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {`${editConfirm.subscriptionIntervalCount}${
                      editConfirm.subscriptionInterval === 'WEEK'
                        ? '週間'
                        : 'ヶ月'
                    }1回`}
                  </TableCell>
                </TableRow>
              )}
              {editConfirm.comboMenu === 1 && (
                <>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      単価 × 発行枚数
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {`${editConfirm.priceCombo}円ｘ${
                        editConfirm.quantityRelease
                      }枚`}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      付与無料枚数
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {editConfirm.quantityPromotion
                        ? `${editConfirm.quantityPromotion}枚`
                        : ''}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      おまけ
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {promotionDescription}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      利用制限
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {(() => {
                        if (editConfirm.numberUsePerDay === 0) {
                          return 'なし';
                        }
                        return '1日1枚';
                      })()}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      利用期限
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {editConfirm.expiration && editConfirm.expiration !== ''
                        ? `${editConfirm.expiration}日間`
                        : editConfirm.expirationEndDate}
                    </TableCell>
                  </TableRow>
                </>
              )}
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  {isFukuoka ? '金額' : '価格'}
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {editConfirm.price}
                  {`円`}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  {isFukuoka ? '税区分' : '税区分'}
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {taxTypes.map(item => {
                    if (editConfirm.taxType.toString() === item.id.toString()) {
                      return item.name;
                    }
                    return '';
                  })}
                </TableCell>
              </TableRow>
              {!isFukuoka && (
                <>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      軽減税率対象
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {(() => {
                        if (editConfirm.reducedTaxType === 'REDUCED') {
                          return '対象';
                        }
                        return '対象外';
                      })()}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      ジャンル
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {menuGenreName}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      シチュエーション
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {menuSituationNames}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      贈り相手
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {menuUserTargetNames}
                    </TableCell>
                  </TableRow>
                </>
              )}
              <TableRow>
                <TableCell className={classes.tableCellItem}>説明</TableCell>
                <TableCell className={classes.tableCellData}>
                  {description}
                </TableCell>
              </TableRow>
              {!isFukuoka && (
                <TableRow>
                  <TableCell className={classes.tableCellItem}>タグ</TableCell>
                  <TableCell className={classes.tableCellData}>
                    {editConfirm.tagStr}
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell className={classes.tableCellItem}>画像</TableCell>
                <TableCell className={classes.tableCellData}>
                  <ImagePreview previewImage={previewImage} />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Paper>
        <div>
          <BackButton onClickAction={backAction} />
          <RegisterButton onClickAction={editAction} />
        </div>
        <ProgressDialog
          openProgress={openEditProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
